import axios from "axios";
import { initialCancelFunction } from "../../../../util/Helpers"

const cancelToken = axios.CancelToken;
let cancelGetUserProfileReq = initialCancelFunction;
let cancelGetUserAccountsReq = initialCancelFunction;
let cancelGetUserAccountDetailsReq = initialCancelFunction;
let cancelGetUserDocumentsReq = initialCancelFunction;
let cancelGetUserBankAccountsReq = initialCancelFunction;
let cancelGetUserSavedCardsReq = initialCancelFunction;
let cancelSearchInstrumentReq = initialCancelFunction;
let cancelInstrumentDetailsReq = initialCancelFunction;
let cancelGetBanksReq = initialCancelFunction;
let cancelGetBankAccountNameReq = initialCancelFunction;
let cancelGetUserSafeLocksReq = initialCancelFunction;
let cancelGetUserLiquidationsReq = initialCancelFunction;


export const USERS_URL = "/users";


// READ
export function getUserProfile(userId) {
  cancelGetUserProfileReq("Cancel Request");
  return axios.get(`${USERS_URL}/profile/${userId}`, {
    cancelToken: new cancelToken(function executor(cancel) {
      // An executor function receives a cancel function as a parameter
      cancelGetUserProfileReq = cancel;
    })
  }
  );
}


// UPDATE => PUT: update the user on the server
export function updateUserProfile(userId, userData) {
  return axios.put(`${USERS_URL}/profile/${userId}`, { ...userData });
}

// DELETE => delete the user from the server
export function deleteUser(userId) {
  return axios.delete(`${USERS_URL}/${userId}`);
}



/**********************************************************************
 * 
 * ACCOUNT CRUD
 * 
 *************************************************************************************************************/

// READ
export function getUserAccounts(userId) {
  cancelGetUserAccountsReq("Cancel Request");
  return axios.get(`${USERS_URL}/account/${userId}`, {
    cancelToken: new cancelToken(function executor(cancel) {
      // An executor function receives a cancel function as a parameter
      cancelGetUserAccountsReq = cancel;
    })
  }
  );
}

// CREATE
export function createTradingAccount(userId, accountData) {
  return axios.post(`${USERS_URL}/account/${userId}`, { ...accountData });
}

// CREATE
export function createReserveAccount(userId, accountId, data) {
  return axios.post(`${USERS_URL}/reserve-account/${userId}/${accountId}`, { ...data });
}

// UPDATE
export function updateReserveAccountInstant(userId, accountId, data) {
  return axios.patch(`${USERS_URL}/reserve-account/${userId}/${accountId}`, { ...data });
}

// READ
export function getUserAccountDetails(userId, accountId) {
  cancelGetUserAccountDetailsReq("Cancel Request");
  return axios.get(`${USERS_URL}/account/${userId}/${accountId}`, {
    cancelToken: new cancelToken(function executor(cancel) {
      // An executor function receives a cancel function as a parameter
      cancelGetUserAccountDetailsReq = cancel;
    })
  }
  );
}

// UPDATE
export function cancelAccountOrder(orderId, meta) {
  return axios.patch(`${USERS_URL}/order/${orderId}/cancel`, { meta });
}

// READ 
export function downloadStatement(userId, accountId, key) {
  return axios.get(`${USERS_URL}/statement/${userId}/${accountId}/${key}`, { responseType: 'blob' });
}

/**********************************************************************
 * 
 * DOCUMENT CRUD
 * 
 *************************************************************************************************************/

// READ
export function getUserDocuments(userId) {
  cancelGetUserDocumentsReq("Cancel Request");
  return axios.get(`${USERS_URL}/document/${userId}`, {
    cancelToken: new cancelToken(function executor(cancel) {
      // An executor function receives a cancel function as a parameter
      cancelGetUserDocumentsReq = cancel;
    })
  }
  );
}

// CREATE
export function uploadUserDocument(userId, docData) {
  return axios.post(`${USERS_URL}/document/${userId}`, { ...docData });
}

// READ
export function getSearchInstruments(query, provider) {
  cancelSearchInstrumentReq("Cancel Request");
  return axios.get(`${USERS_URL}/instruments?query=${query}&provider=${provider}`, {
    cancelToken: new cancelToken(function executor(cancel) {
      // An executor function receives a cancel function as a parameter
      cancelSearchInstrumentReq = cancel;
    })
  }
  );
}

// READ
export function getInstrumentDetails(instrumentId) {
  cancelInstrumentDetailsReq("Cancel Request");
  return axios.get(`${USERS_URL}/instruments/${instrumentId}?quote=only`, {
    cancelToken: new cancelToken(function executor(cancel) {
      // An executor function receives a cancel function as a parameter
      cancelInstrumentDetailsReq = cancel;
    })
  }
  );
}

// CREATE
export function createOrder(data) {
  return axios.post(`${USERS_URL}/order`, { ...data });
}

// CREATE
export function createWithdrawal(data) {
  return axios.post(`${USERS_URL}/withdraw`, { ...data });
}

/**********************************************************************
 * 
 * BANK ACCOUNT  CRUD
 * 
 *************************************************************************************************************/

// READ
export function getBanks() {
  cancelGetBanksReq("Cancel Request");
  return axios.get(`${USERS_URL}/banks`, {
    cancelToken: new cancelToken(function executor(cancel) {
      // An executor function receives a cancel function as a parameter
      cancelGetBanksReq = cancel;
    })
  }
  );
}

// READ
export function getUserBankAccounts(userId) {
  cancelGetUserBankAccountsReq("Cancel Request");
  return axios.get(`${USERS_URL}/bank-account/${userId}`, {
    cancelToken: new cancelToken(function executor(cancel) {
      // An executor function receives a cancel function as a parameter
      cancelGetUserBankAccountsReq = cancel;
    })
  }
  );
}

// READ
export function getBankAccountName(bankRef, accountNumber) {
  cancelGetBankAccountNameReq("Cancel Request");
  return axios.get(`${USERS_URL}/bank-account/${bankRef}/${accountNumber}`, {
    cancelToken: new cancelToken(function executor(cancel) {
      // An executor function receives a cancel function as a parameter
      cancelGetBankAccountNameReq = cancel;
    })
  }
  );
}

// CREATE
export function addNewBankAccount(data) {
  return axios.post(`${USERS_URL}/bank-account`, { ...data });
}

// DELETE
export function deleteBankAccount(userId, ref, data) {
  return axios.delete(`${USERS_URL}/bank-account/${userId}/${ref}`, { data });
}


/**********************************************************************
 * 
 * SAVED CARD CRUD
 * 
 *************************************************************************************************************/

// READ
export function getUserSavedCards(userId) {
  cancelGetUserSavedCardsReq("Cancel Request");
  return axios.get(`${USERS_URL}/saved-card/${userId}`, {
    cancelToken: new cancelToken(function executor(cancel) {
      // An executor function receives a cancel function as a parameter
      cancelGetUserSavedCardsReq = cancel;
    })
  }
  );
}


// DELETE
export function deleteSavedCard(userId, cardId, data) {
  return axios.delete(`${USERS_URL}/saved-card/${userId}/${cardId}`, { data });
}

/**********************************************************************
 * 
 * EARN CRUD
 * 
 *************************************************************************************************************/

// READ
export function getUserSafeLocks(email) {
  cancelGetUserSafeLocksReq("Cancel Request");
  return axios.get(`${USERS_URL}/safe-lock/${email}`, {
    cancelToken: new cancelToken(function executor(cancel) {
      // An executor function receives a cancel function as a parameter
      cancelGetUserSafeLocksReq = cancel;
    })
  }
  );
}

// READ
export function getUserLiquidations(email) {
  cancelGetUserLiquidationsReq("Cancel Request");
  return axios.get(`${USERS_URL}/liquidations/${email}`, {
    cancelToken: new cancelToken(function executor(cancel) {
      // An executor function receives a cancel function as a parameter
      cancelGetUserLiquidationsReq = cancel;
    })
  }
  );
}




